import { getApiClient, type RequestOpts } from './api-client';
import { ZEUS_SERVICE_URL as servicePath } from '../constants/APIconstants';

export interface ChunkLines {
  from: number;
  to: number;
}

/** A knowledge-item chunk as returned by zeus's chunk retrieval endpoint. */
export interface ChunkContent {
  id: string;
  knowledgeItemId: string;
  title: string;
  chunkTitle: string;
  content: string;
  lines: ChunkLines;
  contentType: string;
  expiresAt: string;
}

// Zeus endpoints on the react-query api-client; the legacy Executer-based
// endpoints live in zeus.service.api.js.
class ZeusRqService {
  // One id, one endpoint: zeus authorizes the read (own-org or a hub-shared chunk
  // the caller is entitled to) and returns it, so the client doesn't classify.
  getChunkById(chunkId: string, { signal }: RequestOpts = {}): Promise<ChunkContent> {
    return getApiClient().get<ChunkContent>(`${servicePath}chunks/${chunkId}`, { signal });
  }
}

export default new ZeusRqService();
